const TokenKey = 'App-Token'
const VisitorKey = 'App-Visitor'

export function getToken() {
    // 获取token缓存
    return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}
export function removeToken() {
  return localStorage.removeItem(TokenKey)
}


export function setVisitor(value) {
  return localStorage.setItem(VisitorKey, value)
}
export function getVisitor() {
  return localStorage.getItem(VisitorKey)
}
